module.exports = __webpack_public_path__ + "static/pc-c7d187c78e66f38f61c7d5fe5deb30c7.png";